import { Skeleton } from "@mui/material"
import { IndividualSmilesMoleculeHighlightingType } from "../../routes/Resultsets/pages/IndividualResultset"
import ScoreValue from "./GridComponentTypes/ScoreValue"
import HighlightComponent from "./GridComponentTypes/HighlightComponent"

export default function MoleculeHighlightingGrid({
    isLoading,
    data,
    threshold,
    setPopupMessage
} : {
    isLoading: boolean,
    data: {
        id: string,
        name: string,
        moleculeHighlightingData: IndividualSmilesMoleculeHighlightingType[],
        smiles: string,
        score: string | number | number[],
    }[],
    threshold: number | null,
    setPopupMessage: (popupMessage: string, isSuccessMessage: boolean) => void
}) {

    return (
        <div className="w-full data-grid highlighting">
            {isLoading ? (
                <>
                {Array.from(Array(6).keys()).map(key => (
                    <Skeleton key={key} variant='rounded' width='100%' height={400}/>
                ))}
                </>
            ) : data.length > 0 ? (
                <>
                {data.map(d => (
                    <div key={d.id} className="w-full flex flex-col justify-start items-stretch rounded-xl bg-white border border-outline">
                        <div className="w-full flex justify-between items-center gap-4 px-6 pt-6">
                            <p className="text-[16px] font-semibold text-default">
                                {d.name}
                            </p>
                            <ScoreValue 
                                value={d.score}
                                threshold={threshold}
                            />
                        </div>
                        <HighlightComponent 
                            data={d}
                            setPopupMessage={setPopupMessage}
                        />
                    </div>
                ))}
                </>
            ) : (
                <></>
            )}
        </div>
    )
}